import { render, staticRenderFns } from "./wifiCommunication.vue?vue&type=template&id=206d48ca&scoped=true"
import script from "./wifiCommunication.vue?vue&type=script&lang=js"
export * from "./wifiCommunication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206d48ca",
  null
  
)

export default component.exports